import { registerWeapon } from './registry';
import { AXE_SPLIT_CRATER } from '../terrain/crater-shapes';

const DIRT_BALL = registerWeapon({
  id: 'dirt_ball',
  name: 'Dirt Ball',
  description: 'Zero damage. Creates a giant crag of new terrain. Inverse of Digger.',
  tier: 'UNCOMMON',
  rarity: 'uncommon',
  projectileRadius: 10,
  projectileSpeed: 0.50,
  color: 0x886644,
  gravity: 0.15,
  bounces: 0,
  bounceEnergyRetention: 0.85,
  damage: 0,
  blastRadius: 160,
  knockbackMult: 0.01,
  knockbackRadius: 0.5,
  shakeIntensity: 1.8,
  particleScale: 1.8,
  craterShape: AXE_SPLIT_CRATER,
  fillsTerrain: true,
});
